import { TextoService } from "src/app/services/texto.service";
import { EventEmitterService } from "./event-emitter.service";
import { Observable, throwError } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { MessageService } from "./message.service";
import { Router } from "@angular/router";
import { AuthenticationService } from "./authentication.service";
import { catchError } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class TermoAceiteService {
  constructor(
    private httpClient: HttpClient,
    private messageService: MessageService,
    private TextoService: TextoService,
    private router: Router,
    private _auth: AuthenticationService
  ) {}

  enviarpdfBeneficiario(termo: string, autorizacao: boolean): Observable<any> {
    return this.httpClient
      .post<any>(`${environment.apiBase}termo/beneficiario/aceite`, {
        termo,
        beneficiarioId: this._auth.currentUserValue.id,
        autorizado: autorizacao,
      })
      .pipe(
        catchError((err) => {
          this.messageService.showError(this.TextoService.ErroGenerico);
          EventEmitterService.get("AlteraLoading").emit(false);
          return throwError(() => err); // Propaga o erro como observable
        })
      );
  }

  enviarPdfRevogacao(termo: string, autorizacao: boolean): Observable<any> {
    return this.httpClient
      .post<any>(`${environment.apiBase}termo/beneficiario/revogar`, {
        termo,
        beneficiarioId: this._auth.currentUserValue.id,
        autorizado: autorizacao,
      })
      .pipe(
        catchError((err) => {
          this.messageService.showError(this.TextoService.ErroGenerico);
          EventEmitterService.get("AlteraLoading").emit(false);
          return throwError(() => err); // Propaga o erro como observable
        })
      );
  }

  async enviarpdfProfissional(
    termo: string,
    autorizacao: boolean
  ): Promise<void> {
    try {
      await this.httpClient
        .post<any>(`${environment.apiBase}termo/profissional/aceite`, {
          termo,
          autorizado: autorizacao,
        })
        .toPromise();
    } catch (err) {
      this.messageService.showError(this.TextoService.ErroGenerico);
      EventEmitterService.get("AlteraLoading").emit(false);
      throw err;
    }
  }

  visuTermoBeneficiario(): Observable<any> {
    return this.httpClient.get(
      `${environment.apiBase}termo/beneficiario/visualizar`,
      { responseType: "blob" }
    );
  }
}
